interface IsExpectedSocureSessionFailureParams {
  message: string
}

// The SDK surfaces a failed device-session-window request under these base messages depending on the
// entry point (init / re-key / the fold's window step). It's its fail-open path when it can't establish a
// session window — most often because the device cookie was blocked or evicted — leaving no device signal
// to recover, rather than a fault in our integration.
const SOCURE_SESSION_WINDOW_FAILURE_MESSAGES = ['Failed to create new session window', 'Failed to create session']

/**
 * True when a Socure SDK rejection is the expected device-session-window failure: it fails open (login is
 * unaffected) and is unrecoverable client-side, so callers swallow it rather than reporting it. Distinct
 * from {@link isSocureSessionAssociationError}, where a window exists but the association POST failed and
 * re-keying can still recover.
 */
export const isExpectedSocureSessionFailure = ({ message }: IsExpectedSocureSessionFailureParams): boolean =>
  SOCURE_SESSION_WINDOW_FAILURE_MESSAGES.some((failureMessage) => message.startsWith(failureMessage))
